import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CommentLanguageIcon,
  emptyFragment,
  Typography,
} from '@execonline-inc/execonline-ui';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { getLanguageEnglishNames } from '../../../../../../SupportedLanguages/Types';
import { T } from '../../../../../../Translations';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import Competencies from '../ExperiencePopover/Competencies';
import ProgramDates from '../ExperiencePopover/ProgramDates';

interface Props {
  experienceResource: ExperienceDictionaryEntryResponse;
}

function ExperienceVideoDetailsModalBody({ experienceResource }: Props) {
  return (
    <Card className="absolute inset-0 shadow-none" radius="none">
      <CardHeader className="px-6 pt-8 shadow-none sm:pt-0">
        <div className="flex flex-grow flex-col gap-y-3">
          <Typography
            className="text-gray-800"
            variant="subtitleMedium"
            as="h5"
            fontWeight="medium"
          >
            <AlreadyTranslated content={experienceResource.payload.title} />
          </Typography>
        </div>
      </CardHeader>
      <CardBody className="gap-y-4 px-6">
        <div className="flex flex-col gap-y-1">
          {experienceResource.payload.duration
            .map((duration) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} week" count={duration} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
          {experienceResource.payload.hoursPerWeek
            .map((count) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} hour per week" count={count} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
          {experienceResource.payload.totalHours
            .map((totalHours) => (
              <Typography variant="caption" as="p">
                <T kind="{{count}} total hour" count={totalHours} />
              </Typography>
            ))
            .getOrElse(emptyFragment)}
        </div>
        <div className="flex items-center gap-x-2">
          <CommentLanguageIcon size="md" />
          <Typography variant="caption">
            <T
              kind="Available in <span>{{languages}}</span>"
              languages={getLanguageEnglishNames(
                experienceResource.payload.supportedLanguageCodes,
              ).join(', ')}
              span={(languages) => <>{languages}</>}
            />
          </Typography>
        </div>
        <Typography variant="caption" className="whitespace-pre-line">
          <AlreadyTranslated content={experienceResource.payload.description} />
        </Typography>
        <Competencies experience={experienceResource} />
        <ProgramDates />
      </CardBody>
      <CardFooter className="gap-y-2 px-6 pb-8 empty:pt-0">
        <Button
          color="gray"
          fullWidth
          data-intercom-target="discovery-portal-video-modal-enroll-button"
        >
          <T kind="Enroll" />
        </Button>
      </CardFooter>
    </Card>
  );
}

export default observer(ExperienceVideoDetailsModalBody);
